<ion-content class="tutorial-control">
  <div class="close-btn" (click)="closeTutorial()">
    <img ngSrc="assets/icon/close.svg" alt="close" height="12" width="12">
  </div>

  <div class="tutorial-swiper">
    <div class="swiper-wrapper">

      <!-- Slide 1 -->
      <div class="swiper-slide">
        <ion-grid>
          <ion-row class="row-action">
            <ion-col>
              <img class="example-control" src="assets/tutorial/images/example-control.gif" alt="example control">

              <div class="arrows">

                <div class="empty-square"></div>

                <!--arrow-up-->
                <div>
                  <div class="arrow-up">
                    <img src="assets/tutorial/icon/arrow.svg" alt="arrow up">
                    <span> 89° </span>
                  </div>
                </div>

                <div class="empty-square"></div>

                <!--arrow-left-->
                <div>
                  <div class="arrow-left">
                    <img src="assets/tutorial/icon/arrow.svg" alt="arrow left">
                    <span class="arrow-left"> 45° </span>
                  </div>
                </div>

                <div class="empty-square"></div>

                <!--arrow-right-->
                <div>
                  <div class="arrow-right">
                    <img src="assets/tutorial/icon/arrow.svg" alt="arrow right">
                    <span> 15° </span>
                  </div>
                </div>

                <div class="empty-square"></div>

                <!--arrow-down-->
                <div>
                  <div class="arrow-down">
                    <img src="assets/tutorial/icon/arrow.svg" alt="arrow down">
                    <span> 10° </span>
                  </div>
                </div>

                <div class="empty-square"></div>

              </div>
            </ion-col>
          </ion-row>

          <ion-row class="row-description">
            <ion-col>
              <p> {{ 'avatar.tutorialControl.description.slide_1' | translate }} </p>
            </ion-col>
          </ion-row>

          <ion-row class="row-button">
            <ion-col>
              <ion-button (click)="toNextSlide()" class="button-bottom" color="dark" expand="block">
                {{ 'avatar.tutorialControl.next' | translate }}
              </ion-button>
              <a class="sr-only" href="/avatar">Next</a>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <!-- Slide 2 -->
      <div class="swiper-slide">
        <ion-grid>
          <ion-row class="row-action">
            <ion-col>
              <img id="target-point" src="assets/icon/pin-to.gif" alt="target point">
            </ion-col>
          </ion-row>

          <ion-row class="row-description">
            <ion-col>
              <p> {{ 'avatar.tutorialControl.description.slide_2' | translate }} </p>
            </ion-col>
          </ion-row>

          <ion-row class="row-button">
            <ion-col>
              <ion-button (click)="toNextSlide()" class="button-bottom" color="dark" expand="block">
                {{ 'avatar.tutorialControl.next' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <!-- Slide 3 -->
      <div class="swiper-slide">
        <ion-grid>
          <ion-row class="row-action">
            <ion-col>
              <div class="rotation">
                <!--go-ahead-->
                <div class="rotation-action">
                  <span> <img src="assets/tutorial/icon/go-arrow.svg" alt="forward"> </span>
                  {{ 'avatar.video_sharing.go' | translate }}
                </div>

                <!--stop-->
                <div class="rotation-action">
                  <span>
                    {{ 'avatar.video_sharing.stop' | translate }}
                  </span>
                </div>

                <!--turn-left-->
                <div class="rotation-action">
                  <span> <img src="assets/tutorial/icon/turn-left.svg" alt="turn left"> </span>
                  {{ 'avatar.video_sharing.turn_left' | translate }}
                </div>

                <!--turn-right-->
                <div class="rotation-action">
                  <span> <img src="assets/tutorial/icon/turn-right.svg" alt="turn right"> </span>
                  {{ 'avatar.video_sharing.turn_right' | translate }}
                </div>

                <!--left-around-->
                <div class="rotation-action">
                  <span> <img src="assets/tutorial/icon/left-around.svg" alt="left around"> </span>
                  {{ 'avatar.video_sharing.turn_around' | translate }}
                </div>

                <!--right-around-->
                <div class="rotation-action">
                  <span> <img src="assets/tutorial/icon/right-around.svg" alt="right around"> </span>
                  {{ 'avatar.video_sharing.turn_around' | translate }}
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="row-description">
            <ion-col>
              <p> {{ 'avatar.tutorialControl.description.slide_3' | translate }} </p>
            </ion-col>
          </ion-row>

          <ion-row class="row-button">
            <ion-col>
              <ion-button (click)="finishLearning()" class="button-bottom" color="dark" expand="block">
                {{ 'avatar.tutorialControl.letStart' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>

  <div class="swiper-pagination tutorial-pagination"></div>
</ion-content>
